import { format } from "date-fns";
import formatDistanceToNow from "date-fns/formatDistanceToNow";

export const DATE_FORMAT_MMM_DO_YYYY = "MMM do yyyy";
export const DATE_FORMAT_YYYY_MM_DD = "yyyy-MM-dd";

type dateFormat = "MM/dd/yyyy" | "MMM do" | "MMM do yyyy" | "HH:mm aa" | "h:mm aa" | "p";

export function formatDate(timeStamp: string, formatType: dateFormat): string {
  return timeStamp ? format(new Date(timeStamp), formatType) : "N/A";
}

export function formatDateToNow(timeStamp: string): string {
  return timeStamp ? formatDistanceToNow(new Date(timeStamp)) : "N/A";
}

export const formatSessionTime = (sessionTime: Date) => {
  const day = sessionTime.getDate();
  const ordinal =
    day +
    (day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th");

  const month = sessionTime.toLocaleDateString("en-US", { month: "long" });
  const time = sessionTime.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short"
  });

  return `${month} ${ordinal} | ${time}`;
};
